import { ArcView, Color, Length, SvgView, } from '@swim/ui';
var FlowView = (function () {
    function FlowView(parentView) {
        this.parentView = parentView;
        this.observers = [];
        this._meter = 0;
        this._innerRadius = Length.zero();
        this._outerRadius = Length.zero();
        this._faceColor = Color.black();
        this._dialColor = Color.black();
        this._dialCornerRadius = Length.zero();
        this._value = null;
        this.gaugeBox = SvgView.create('g')
            .className('gauge-box');
        this.parentView.append(this.gaugeBox);
        this.arcGroup = SvgView.create('g')
            .className('arc-group');
        this.gaugeBox.append(this.arcGroup);
        this.face = ArcView.create('face')
            .setAttribute('class', 'face');
        this.face.deltaAngle(2 * Math.PI * 1, undefined);
        this.arcGroup.append(this.face);
        this.dial = ArcView.create('dial')
            .setAttribute('class', 'dial');
        this.dial.deltaAngle(2 * Math.PI * 0, undefined);
        this.arcGroup.append(this.dial);
    }
    FlowView.prototype.width = function (value, parentNode) {
        if (value === undefined) {
            return this._width;
        }
        else {
            if (value === null) {
                this._width = Length.zero(this.parentView.node);
            }
            else {
                this._width = (value instanceof Length) ? value : Length.px(value, parentNode);
            }
            return this;
        }
    };
    FlowView.prototype.height = function (value, parentNode) {
        if (value === undefined) {
            return this._height;
        }
        else {
            if (value === null) {
                this._height = Length.zero(this.parentView.node);
            }
            else {
                this._height = (value instanceof Length) ? value : Length.px(value, parentNode);
            }
            return this;
        }
    };
    FlowView.prototype.meter = function (value) {
        if (value === undefined) {
            return this._meter;
        }
        else {
            this._meter = (value) ? value : 0;
            return this;
        }
    };
    FlowView.prototype.parentResize = function () {
        var node = this.parentView.node;
        do {
            var parentNode = node.parentNode;
            if (parentNode) {
                if (parentNode instanceof HTMLElement) {
                    var width = parentNode.offsetWidth;
                    var height = parentNode.offsetHeight;
                    this.parentView.width(width)
                        .height(parentNode.offsetHeight);
                    this.width(width, parentNode);
                    this.height(height, parentNode);
                    return;
                }
                node = parentNode;
                continue;
            }
            return;
        } while (true);
    };
    FlowView.prototype.gaugeResize = function () {
    };
    FlowView.prototype.resize = function () {
        this.parentResize();
        this.gaugeResize();
    };
    FlowView.prototype.render = function () {
    };
    FlowView.create = function (tag) {
        if (tag === void 0) { tag = 'svg'; }
        var parentView = SvgView.create(tag)
            .className('flow')
            .setProperty({
            '-webkit-user-select': 'none',
            '-moz-user-select': 'none',
            '-ms-user-select': 'none',
            'user-select': 'none',
            'cursor': 'default',
        });
        return new FlowView(parentView);
    };
    return FlowView;
}());
export { FlowView };
//# sourceMappingURL=data:application/json;base64,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